import { FileExcelOutlined, FileImageOutlined, FilePdfOutlined, FilePptOutlined, FileWordOutlined, FileZipOutlined, FolderOutlined } from '@ant-design/icons';
import styled from 'styled-components';
const style = `
background-color: #c4c4c4;
color: #fff;
padding: 10px 5px;
border-radius: 5px;
font-size: 30px;
`;
export const CustomPDF = styled(FilePdfOutlined)`
  ${style}
`;
export const CustomWord = styled(FileWordOutlined)`
  ${style}
`;
export const CustomExcel = styled(FileExcelOutlined)`
  ${style}
`;
export const CustomImage = styled(FileImageOutlined)`
  ${style}
`;
export const CustomPPT = styled(FilePptOutlined)`
  ${style}
`;
export const CustomFolder = styled(FolderOutlined)`
  ${style}
`;
export const CustomZip = styled(FileZipOutlined)`
  ${style}
`;